    <header class="page-head">
      <div>
        <h1 class="page-title">My Account</h1>
        <p class="page-subtitle">Update personal details, contact preferences, access details, and OTP delivery options.</p>
      </div>
    </header>

    <section class="detail-grid">
      <div class="detail-card span-6">
        <h2 class="section-title">Personal details</h2>
        <form class="form-stack" [formGroup]="profileForm">
          <div class="field-grid">
            <div class="input-group">
              <label>Full name</label>
              <input formControlName="fullName" />
            </div>
            <div class="input-group">
              <label>Email</label>
              <input formControlName="email" />
            </div>
            <div class="input-group">
              <label>Phone number</label>
              <input formControlName="phoneNumber" />
            </div>
            <div class="input-group">
              <label>Physical address</label>
              <textarea formControlName="physicalAddress"></textarea>
            </div>
          </div>
        </form>
      </div>

      <div class="detail-card span-6">
        <h2 class="section-title">Preferences and access</h2>
        <form class="form-stack" [formGroup]="securityForm">
          <div class="input-group">
            <label>Contact preferences</label>
            <select formControlName="contactPreference">
              <option value="email">Email</option>
              <option value="sms">SMS</option>
              <option value="whatsapp">WhatsApp</option>
            </select>
          </div>
          <div class="input-group">
            <label>Change login email</label>
            <input formControlName="loginEmail" />
          </div>
          <div class="input-group">
            <label>New password</label>
            <input type="password" formControlName="newPassword" />
          </div>
          <div class="input-group">
            <label>OTP delivery option</label>
            <select formControlName="otpDelivery">
              <option value="sms">SMS</option>
              <option value="email">Email</option>
              <option value="whatsapp">WhatsApp</option>
            </select>
          </div>
          <button class="btn btn-primary" type="button">Update account details</button>
        </form>
      </div>
    </section>
